var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinutes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 33c.5 0 1-.438 1-1V14h-5c-1.125 0-2-.875-2-2V7H12c-.563 0-1 .5-1 1v24c0 .563.438 1 1 1zM8 8c0-2.188 1.75-4 4-4h10.313c1.062 0 2.062.438 2.812 1.188l5.688 5.687c.75.75 1.187 1.75 1.187 2.813V32c0 2.25-1.813 4-4 4H12c-2.25 0-4-1.75-4-4zm0 0",
    fill: "#fff"
  })));
}
export default SvgMinutes;